import { render, staticRenderFns } from "./ThankyouStep.vue?vue&type=template&id=82a91234"
import script from "./ThankyouStep.vue?vue&type=script&lang=js"
export * from "./ThankyouStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82a91234')) {
      api.createRecord('82a91234', component.options)
    } else {
      api.reload('82a91234', component.options)
    }
    module.hot.accept("./ThankyouStep.vue?vue&type=template&id=82a91234", function () {
      api.rerender('82a91234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/future_house_awards/components/ThankyouStep.vue"
export default component.exports